export enum Interaction {
  InitialDataLoad = 'csr.initialDataLoad',
  InitialWidgetRender = 'csr.initialWidgetRender',
  EnterPublicProfilePreview = 'cta.enterPublicProfilePreview',
}
